<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { RouterView } from 'vue-router'
import { useLocaleStore } from '@/stores/locale'
import { useAuthStore } from '@/stores/auth'
import { useEntitlementsStore } from '@/stores/entitlements'

const localeStore = useLocaleStore()
const authStore = useAuthStore()
const entitlements = useEntitlementsStore()

onMounted(() => {
  localeStore.initialize()
  // Restore + validate a persisted session (no-op when signed out).
  void authStore.loadSession()
})

// Load plan + limits whenever a session appears (app start / sign-in); clear on
// sign-out. Drives the client-side gating and the paywall.
watch(
  () => authStore.isAuthenticated,
  (signedIn) => {
    if (signedIn) void entitlements.load()
    else entitlements.clear()
  },
  { immediate: true }
)
</script>

<template>
  <RouterView />
</template>
